var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoReplay = function SvgIcoReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "#fff",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.612 14.893a8.333 8.333 0 1 0 .81-12.499l-.633-.633a.5.5 0 0 0-.849.283L.587 4.519a.5.5 0 0 0 .565.565l2.475-.353a.5.5 0 0 0 .283-.849l-.297-.297a6.668 6.668 0 0 1 8.605 10.129 6.667 6.667 0 0 1-9.428 0 .833.833 0 0 0-1.178 1.178m4.71-2.686 4.094-2.472a.857.857 0 0 0 0-1.471L6.322 5.792a.9.9 0 0 0-.453-.125c-.48 0-.869.385-.869.86v4.945c0 .158.044.313.127.448a.874.874 0 0 0 1.195.287",
    clipRule: "evenodd"
  })));
};
export default SvgIcoReplay;